// @ts-nocheck


const CURSOR_GLOW_W = "2.2";
const CURSOR_GLOW_OP = ".2";
const CURSOR_GLOW_BLUR = "0.7";

function studioCursorUrl(accent, active = false) {
  const path =
    "M4 6.3 L4 19.9 Q4 21.9 5.258 20.346 L7.4 17.7 C8.4 16.4 9.9 15.7 11.5 15.7 L14.902 15.826 Q16.9 15.9 15.414 14.562 L5.486 5.638 Q4 4.3 4 6.3 Z";
  const glow = `<path d='${path}' fill='none' stroke='${accent}' stroke-width='${CURSOR_GLOW_W}' stroke-opacity='${CURSOR_GLOW_OP}' stroke-linejoin='round' stroke-linecap='round' filter='blur(${CURSOR_GLOW_BLUR}px)'/>`;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 26'>${glow}<path d='${path}' fill='${active ? accent : "none"}' fill-opacity='${active ? 1 : 0}' stroke='${accent}' stroke-width='${active ? 1 : 2}' stroke-linejoin='round' stroke-linecap='round'/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 4 6, auto`;
}

function studioCursorTextUrl(accent) {
  // Vertical I-beam caret (Mercury OS) — not a horizontal bar.
  const glow = `<rect x='1' y='1' width='2' height='16' fill='${accent}' fill-opacity='${CURSOR_GLOW_OP}' rx='1' filter='blur(${CURSOR_GLOW_BLUR}px)'/>`;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='4' height='18' viewBox='0 0 4 18'>${glow}<rect x='1' y='1' width='2' height='16' fill='${accent}' rx='1'/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 2 9, text`;
}

function studioCursorResizeXMarkup(accent) {
  const glow = `<path d='M9 7 L3 7 M5 5 L3 7 L5 9 M19 7 L25 7 M23 5 L25 7 L23 9' fill='none' stroke='${accent}' stroke-width='${CURSOR_GLOW_W}' stroke-opacity='${CURSOR_GLOW_OP}' stroke-linecap='round' stroke-linejoin='round' filter='blur(${CURSOR_GLOW_BLUR}px)'/>`;
  const left = `<path d='M9 7 L3 7 M5 5 L3 7 L5 9' fill='none' stroke='${accent}' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/>`;
  const right = `<path d='M19 7 L25 7 M23 5 L25 7 L23 9' fill='none' stroke='${accent}' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/>`;
  return `${glow}${left}${right}`;
}

function studioCursorResizeXUrl(accent) {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='28' height='14' viewBox='0 0 28 14'>${studioCursorResizeXMarkup(accent)}</svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 14 7, ew-resize`;
}

function studioCursorResizeYUrl(accent) {
  // Same left/right arrows as Mercury OS, rotated for up/down.
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='14' height='28' viewBox='0 0 14 28'><g transform='translate(14 0) rotate(90)'>${studioCursorResizeXMarkup(accent)}</g></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 7 14, ns-resize`;
}

function studioCursorResizeCornerUrl(accent, degrees, fallback) {
  // Horizontal arrows rotated onto a corner diagonal. -45 = bottom-left / top-right
  // (nesw, top-right handle). +45 = top-left / bottom-right (nwse, top-left handle).
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><g transform='translate(16 16) rotate(${degrees}) translate(-14 -7)'>${studioCursorResizeXMarkup(accent)}</g></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 16 16, ${fallback}`;
}

function studioCursorResizeNeswUrl(accent) {
  return studioCursorResizeCornerUrl(accent, -45, "nesw-resize");
}

function studioCursorResizeNwseUrl(accent) {
  return studioCursorResizeCornerUrl(accent, 45, "nwse-resize");
}

function studioCursorDragUrl(accent) {
  const glow = `<circle cx='12' cy='12' r='9' fill='none' stroke='${accent}' stroke-width='${CURSOR_GLOW_W}' stroke-opacity='${CURSOR_GLOW_OP}' filter='blur(${CURSOR_GLOW_BLUR}px)'/>`;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>${glow}<circle cx='12' cy='12' r='9' fill='none' stroke='${accent}' stroke-width='1.6'/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 12 12, grab`;
}

function studioCursorGrabbingUrl(accent) {
  const glow = `<circle cx='14' cy='14' r='11' fill='${accent}' fill-opacity='${CURSOR_GLOW_OP}' filter='blur(${CURSOR_GLOW_BLUR}px)'/>`;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'>${glow}<circle cx='14' cy='14' r='11' fill='${accent}' fill-opacity='.92'/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 14 14, grabbing`;
}

/** Custom cursor tokens (set on :root when polish uses is-custom-cursor):
 *  --studio-cursor-default | active | text | resize-x | resize-y | resize-nesw | resize-nwse | drag | grabbing
 */
export function applyStudioCursorTheme(element) {
  if (!element) return;
  const root = document.documentElement;
  const accent =
    getComputedStyle(document.documentElement).getPropertyValue("--cursor-accent").trim() ||
    "#22c55e";
  root.style.setProperty("--studio-cursor-default", studioCursorUrl(accent, false));
  root.style.setProperty("--studio-cursor-active", studioCursorUrl(accent, true));
  root.style.setProperty("--studio-cursor-text", studioCursorTextUrl(accent));
  root.style.setProperty("--studio-cursor-resize-x", studioCursorResizeXUrl(accent));
  root.style.setProperty("--studio-cursor-resize-y", studioCursorResizeYUrl(accent));
  root.style.setProperty("--studio-cursor-resize-nesw", studioCursorResizeNeswUrl(accent));
  root.style.setProperty("--studio-cursor-resize-nwse", studioCursorResizeNwseUrl(accent));
  root.style.setProperty("--studio-cursor-drag", studioCursorDragUrl(accent));
  root.style.setProperty("--studio-cursor-grabbing", studioCursorGrabbingUrl(accent));
}
